import makeAction from "./../../libs/actions";

export const fetchLinks = makeAction("posts/FETCH_LINKS");
